<template>
    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-10">
                <h1 class="text-2xl font-bold mb-5">Log modifiche fornitore</h1>
                <ol class="space-y-4 list-decimal list-inside">
                    <li v-for="m in modifiche">
                        L'utente <span class="font-bold">{{ m.user.name }}</span> ha modificato il fornitore il <span class="font-bold">{{ $filters.toDate(m.created_at) }}</span>.
                        <ul class="pl-5 mt-2 space-y-1 list-disc list-inside" >
                            <li v-for="(v,k) in m.new_values">Il campo <span class="font-bold">{{k}}</span> è stato cambiato in <span class="font-bold">{{qualificheFornitore[v]}}</span></li>
                        </ul>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import { mapGetters } from 'vuex';
import NextButton from "@/components/NextButton.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import {Paths, QualificheFornitore} from "@/types";
import {dettaglio_fornitore} from "@/BreadcrumbsPath";
import fornitoriManager from "@/api/FornitoriManager";

@Options({
    name: 'FornitoreAudit',
    components: {
        Breadcrumbs, NextButton

    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'me',
        ])
    },
    props: {
        fid: [Number, String],
    }
})
export default class FornitoreAudit extends Vue {
    fid!:number|string;
    modifiche: any[] = [];
    qualificheFornitore = QualificheFornitore;

    get getBreadcrumbsPath(): Paths[] {
        return dettaglio_fornitore
    }

    created(){
        fornitoriManager.audits(this.fid).then((response) => {
            this.modifiche = response.data;
        });
    }
}

</script>


<style lang="scss">

</style>
